import { FileService } from './../services/file.service';
import { ReportingService } from './../services/reporting.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, Injectable, ComponentFactoryResolver, ElementRef } from '@angular/core';
import { NgProgress } from 'ngx-progressbar';
import { Chart, registerables } from 'chart.js';
import { IMenu } from '../models/imenu.model';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { GetDebtorHistory } from '../models/Profile-view.model';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { CommonService } from '../services';
import { MyAccountService } from '../services/myAccount.service';
import { CustomReportEditComponent } from './custom-report-edit/custom-report-edit.component';
import { EventListenerService } from '../services/close-listenenr.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { AuthService } from '../services/auth.service';
import { NgProgressService } from '../services/ngProgress.service';
import { filter } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements OnInit, OnDestroy {
  [x: string]: any;

  title = 'Reporting';
  narrowMode = false;
  loadContent = false;
  closeEvent$: Subscription;
  accountId: string = '';
  chartLoadingStatus = true;
  //excel
  url: string;

  isStaffAccount = false;

  //charts
  totalRevenueChart: any;
  trendingChart: any;
  horizontalBarChart: any;
  transactionalHistoryChart: any;
  transactionalHistoryData: any;

  getDebtorHistory: Array<GetDebtorHistory>;

  //boolean for when the create popup is active
  createActive: boolean = false;

  reportList: any = null;
  
  //Business Menu
  businessMenu: IMenu[] = [
    {
        menuName: 'Sell Through Reports',
        menuId: 'sellThroughReports',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png',
        menuRouter: 'sellthroughreport'
    },
    {
        menuName: 'ETA and Backorder Reports',
        menuId: 'backOrderReports',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png',
        menuRouter: 'backordersreport'
    },
    {
      menuName: 'ESD Report',
      menuId: 'esdReports',
      menuIcon: 'settingButton',
      menuIconUrl: '/images/new_ui/settingIcon-hover.png',
      menuRouter: 'esdreport'
    },
    // {
    //     menuName: 'Shipping Reports',
    //     menuId: 'shippingReports',
    //     menuIcon: 'downloadButton',
    //     menuIconUrl: '/images/new_ui/catalogues-download-hover.png'
    // },
    {
      menuName: 'Web Audit Log',
      menuId: 'webAuditLogs',
      menuIcon: 'settingButton',
      menuIconUrl: '/images/new_ui/settingIcon-hover.png',
      menuRouter: 'webauditlog'
    }
  ]; 
  //Products Menu
  productsMenu: IMenu[] = [
    {
        menuName: 'Serial Number Reports',
        menuId: 'serialNumberReports',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png'
    },
    {
        menuName: 'Renewal Reports',
        menuId: 'renewalReports',
        menuIcon: 'downloadButton',
        menuIconUrl: '/images/new_ui/catalogues-download-hover.png'
    },
    {
        menuName: 'Brand Reports',
        menuId: 'brandReports',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png'
    },
  ];  

  //Subscription Menu
  subscriptionMenu: IMenu[] = [
      {
          menuName: 'Subscription Invoice Reports',
          menuId: 'subscriptionInvoiceReports',
          menuIcon: 'settingButton',
          menuIconUrl: '/images/new_ui/settingIcon-hover.png',
          menuRouter: 'reportingdashboard/SubscriptionInvoiceReports'
      },
      // {
      //     menuName: 'Azure Invoice Reports',
      //     menuId: 'azureInvoiceReports',
      //     menuIcon: 'settingButton',
      //     menuIconUrl: '/images/new_ui/settingIcon-hover.png',
      //     menuRouter: 'reportingdashboard/AzureInvoiceReports'
      // },
      {
          menuName: 'Azure Usage Reports',
          menuId: 'azureUsageReports',
          menuIcon: 'settingButton',
          menuIconUrl: '/images/new_ui/settingIcon-hover.png',
          menuRouter: 'azurereportingdashboard'
      },
    //   {
    //     menuName: 'License Usage Reports',
    //     menuId: 'licenseUsageReports',
    //     menuIcon: 'settingButton',
    //     menuIconUrl: '/images/new_ui/settingIcon-hover.png',
    //     menuRouter: 'licensereportingdashboard'
    // },
      {
        menuName: 'Upcoming MS CSP Renewals',
        menuId: 'upcomingmscsprenewals',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png',
        menuRouter: 'upcomingmicrosoftcsprenewals'
      },
      {
        menuName: 'NCE Orders Report',
        menuId: 'nceordersreport',
        menuIcon: 'settingButton',
        menuIconUrl: '/images/new_ui/settingIcon-hover.png',
        menuRouter: 'NCEOrderReport'
      },
    ];   

  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; //reference to the breadcrumb
  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;  

  @ViewChild('createUpdateReport', { read: ViewContainerRef })
  createUpdateReport: ViewContainerRef;
  @ViewChild('chartTransactionalHistory', {static: false}) chartTransactionalHistory: ElementRef;


  constructor(
    private shoppingCartService: ShoppingCartService,
    private authService: AuthService,
    private reportingService: ReportingService,
    private myAccountService: MyAccountService,
    private commonService: CommonService,
    private fileService: FileService,
    private activateRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private router: Router,
    private closeListener: EventListenerService,
  ) { 
    Chart.register(...registerables);
  }

  ngOnInit() {
    this.ngProgress.start();

    this.shoppingCartService.dashboardChanged.subscribe(aliasLogin => {

      if (this.transactionalHistoryChart) this.transactionalHistoryChart.destroy();

      this.refreshDebtorHistoryChart();
    });

    this.closeEvent$ = this.closeListener.close.subscribe(value => {
      if (value === 'ReportCreateEdit')
      {
        this.createUpdateReport.clear();
        this.createActive = false;
        let el = document.getElementById('levelOne');
        el.style.pointerEvents = 'auto';
      }
    });

    this.authService.getLoginInfo()
    .subscribe((res: CurrentUserModel) => {
      if (res.isStaffAccount || res.isImpersonated) {
        this.isStaffAccount = true;
      } else {
        this.isStaffAccount = false;
      }
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => { 
      this.breadcrumbRef.ngAfterViewInit();

  });


    
    //initialize charts
    if (!this.narrowMode) {
      
      //this.initializeTrendingChart("chartTrending");
      //this.initializeTrendingChart("chartSubsTrending");

      //this.initializeHorizontalBar("chartTopBrands", ["DELL", "LENOVO", "EMC", "MS", "LG"]);
      //this.initializeHorizontalBar("chartTopSKU", ["SKU1", "SKU2", "SKU3", "SKU4", "SKU5"]);
    }
 
    
      //IF an user refresh the web browser
      if(this.router.url != '/reporting'){
        this.narrowMode = true;
      }


    this.router.events
    .subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/reporting') {

          this.narrowMode = false;
      
          $('.page-contents').animate({ scrollLeft: 0 }, 400);

        }
      }
    });

    this.ngProgress.done();
  }

  getLoginInfo() {
    
  }

  refreshDebtorHistoryChart() {
    this.chartLoadingStatus = true;
    this.getDebtorHistory = new Array<GetDebtorHistory>();
    this.authService.getLoginInfo()
    .subscribe((user: CurrentUserModel) => {
      this.accountId = user?.accountId;
      this.myAccountService.getDebtorHistory(this.accountId).subscribe((result: Array<GetDebtorHistory>) => {
        this.chartLoadingStatus = false;
        this.getDebtorHistory = result;
        this.initializeTotalRevenueChart(this.chartTransactionalHistory);
      });
    }, 
    (error: any) => {
      console.info(error);
    });
  }

  initializeTotalRevenueChart(chart: ElementRef) {
    if(chart == undefined) {
      return;
    }
    const ctx = chart.nativeElement;
    var currentMonth = new Date().getMonth();
    var currentYear = this.getDebtorHistory[0];
    var previousYear = this.getDebtorHistory[1];
    var lastPreviousYear = this.getDebtorHistory[2];
    this.transactionalHistoryData = [];
    this.transactionalHistoryData.push({
      label: currentYear.out_period,
      //data: [currentYear.out_01_jan, currentYear.out_02_feb, currentYear.out_03_mar, currentYear.out_04_apr, currentYear.out_05_may, currentYear.out_06_jun, currentYear.out_07_jul, currentYear.out_08_aug, currentYear.out_09_sep, currentYear.out_10_oct, currentYear.out_11_nov, currentYear.out_12_dec],
      data: [currentMonth >= 1 ? currentYear.out_01_jan : null,
      currentMonth >= 2 ? currentYear.out_02_feb : null,
      currentMonth >= 3 ? currentYear.out_03_mar : null,
      currentMonth >= 4 ? currentYear.out_04_apr : null,
      currentMonth >= 5 ? currentYear.out_05_may : null,
      currentMonth >= 6 ? currentYear.out_06_jun : null,
      currentMonth >= 7 ? currentYear.out_07_jul : null,
      currentMonth >= 8 ? currentYear.out_08_aug : null,
      currentMonth >= 9 ? currentYear.out_09_sep : null,
      currentMonth >= 10 ? currentYear.out_10_oct : null,
      currentMonth >= 11 ? currentYear.out_11_nov : null,
      currentMonth >= 12 ? currentYear.out_12_dec : null],
      borderColor: '#C20047',
      backgroundColor: '#C20047',
      fill: false
    });

    this.transactionalHistoryData.push({
      label: previousYear.out_period,
      data: [previousYear.out_01_jan, previousYear.out_02_feb, previousYear.out_03_mar, previousYear.out_04_apr, previousYear.out_05_may, previousYear.out_06_jun, previousYear.out_07_jul, previousYear.out_08_aug, previousYear.out_09_sep, previousYear.out_10_oct, previousYear.out_11_nov, previousYear.out_12_dec],
      borderColor: '#FFD1D1',
      backgroundColor: '#FFD1D1',
      fill: false
    });


    this.transactionalHistoryData.push({
      label: lastPreviousYear.out_period,
      data: [lastPreviousYear.out_01_jan, lastPreviousYear.out_02_feb, lastPreviousYear.out_03_mar, lastPreviousYear.out_04_apr, lastPreviousYear.out_05_may, lastPreviousYear.out_06_jun, lastPreviousYear.out_07_jul, lastPreviousYear.out_08_aug, lastPreviousYear.out_09_sep, lastPreviousYear.out_10_oct, lastPreviousYear.out_11_nov, lastPreviousYear.out_12_dec],
      borderColor: '#666666',
      backgroundColor: '#666666',
      fill: false
    });


    this.transactionalHistoryChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        datasets: this.transactionalHistoryData
      },
      options: {
        responsive: true,
        elements:{
          line: {
            tension: 0.3
          }
        },
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem) {
                return tooltipItem.formattedValue.toLocaleString();
              }
            }
          },
          legend: {
            display: true,
            position: 'right',
            labels: {
              padding: 30,
              usePointStyle: true
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          xAxes: {
            display: true,
            ticks: {
              maxTicksLimit: 0,
              padding: 5,
              font: {
                size: 10,
                style: 'normal'
              },
            }
          },
          yAxes: {
            display: true,
            grid: {
              borderDash:[3,3]
            },
            ticks: {
              callback: function (label, index, labels) {
                return label.toLocaleString();
              },
              maxTicksLimit: 15,
              padding: 3,
              font: {
                size: 10,
                style: 'normal'
              }
            }
          },
        }
      }
    });
  }

  // initializeTrendingChart(id: string) {
  //   const ctx = document.getElementById(id);
    
  //   this.totalRevenueChart = new Chart(ctx, {
  //     type: 'line',
  //     data: {
  //       labels: ['10','20','30','40','50','60','70','80','90'],
  //       datasets: [
  //         { 
  //           label: '90 Day Trending',
  //           data: [1000, 3300, 4400, 5100, 2200, 3200, 2010, 3020, 5810],
  //           borderColor: '#C20047',
  //           backgroundColor: '#C20047',
  //           fill: 'boundary'
  //         }
  //       ]
  //     },
  //     options: {
  //       maintainAspectRatio: false,
  //       spanGaps: false,
  //       elements: {
  //         line: {
  //           tension: 0.000001
  //         }
  //       },
  //       plugins: {
  //         filter: {
  //           propagate: false
  //         }
  //       },
  //       scales: {
  //         xAxes: [{
  //           ticks: {
  //             autoSkip: false,
  //             maxRotation: 0
  //           }
  //         }]
  //       }
  //     }
  //   });
  // }

  // initializeHorizontalBar(id: string, labels: string[]) {
  //   const ctx = document.getElementById(id);

  //   this.horizontalBarChart = new Chart(ctx, {
  //      type: "horizontalBar",
  //      data: {
  //       labels: labels,
  //       datasets: [
  //         {
  //           borderColor: '#C20047',
  //           backgroundColor: '#C20047',
  //           data:[5555,4111,3222,2333,1444]
  //         }
  //       ]
  //      },
  //      options: {
  //       scales: {
  //         yAxes: [{
  //             barThickness : 8
  //         }]
  //        },
  //        responsive:true,
  //         legend: { display: false },
  //         barPercentage: 0.9
  //      }
  //   });
  // }

  // createNewPopup (id = 0) {
  //   // grey out the screen - div with the ID of levelone
  //   this.createActive = true;
  //   let el = document.getElementById('levelOne');
  //   el.style.pointerEvents = 'none';
     
  //   // open up the popup of the create report screen
  //   const comFactory = this.resolver.resolveComponentFactory(CustomReportEditComponent)
  //   const component = this.createUpdateReport.createComponent(comFactory);
  //   if (id > 0) {
  //     (<CustomReportEditComponent>component.instance).report = this.reportList[id];
  //   }

  // }

  downloadReports(reportType:string) {
    if (reportType === 'ETA and Backorder Reports') {
      //$('#backOrderReports').showValidator('Backorder data will be downloaded shortly', 'success', 'right');
      this.commonService.implementToast('Backorder data will be downloaded shortly', 'Info');
      this.exportBackOrdersReport();
    } 
  }

  downloadAdobeReports = () => {
    let form = document.getElementById('downloadForm') as HTMLFormElement;
    if (!form) {
      form = document.createElement('form') as HTMLFormElement;
      form.id = 'downloadForm';
      form.action = '/ExportExcel/GetAdobeRenewalsDowngradeReport';
      form.method = 'POST';
      form.enctype = 'multipart/form-data';
      document.body.appendChild(form);
    }
    // form.submit();
    $('#downloadForm').submit();
  }

  exportBackOrdersReport() {
    this.ngProgress.start();

    this.reportingService.exportBackOrdersReport()
    .subscribe((data:any) => {

      const fileName = `DD_Backorders_${this.accountId}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();

        //this.commonService.implementToast('Backorder data downloaded successfully', 'Success');

        this.router.navigateByUrl('/reporting');

    },
    (error: any) => {
      console.info(error);
       this.ngProgress.done();
    })
  }

  changeMode(event): void {
    event.preventDefault();
    event.stopPropagation();

    this.narrowMode = true;
  }

  onLoading(currentLoadingStatus: boolean) {
    
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.closeEvent$.unsubscribe();
  }

  close() { 
    if(this.narrowMode){
      this.router.navigateByUrl('/reporting');
    }else{
        this.router.navigateByUrl('/home');
    }
  }

}

